import { queryOptions } from '@tanstack/react-query';
import { fetchApi } from '@/std/api/fetchApi';
import { URL_ATUAL } from '@/std/url';
import { EmpresaSlugPublicoSchema } from '../types/EmpresaSlugPublico';

export enum EmpresaSlugConsultarTipoUso {
    Catalogo = 1,
    SegundaVia = 2,
}

type EmpresaSlugConsultarParams = {
    slug: string;
    tipo_uso: EmpresaSlugConsultarTipoUso;
};

function apiEmpresaSlugConsultar(params: EmpresaSlugConsultarParams) {
    return fetchApi({
        empresaIdpk: false,
        endpoint: 'EmpresaSlug/Consultar',
        method: 'get',
        params: { url: URL_ATUAL, ...params },
        schema: EmpresaSlugPublicoSchema,
        token: false,
    });
}

const EMPRESA_SLUG_CONSULTAR_KEY = 'apiEmpresaSlugConsultar';

export function queryOptionsEmpresaSlugConsultar(params: EmpresaSlugConsultarParams) {
    return queryOptions({
        queryFn: () => apiEmpresaSlugConsultar(params),
        queryKey: [EMPRESA_SLUG_CONSULTAR_KEY, params],
    });
}
